export { ImagePolicyPage as default } from '@/components/enpages/Legal/ImagePolicy'
